import React, { useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';
import  EnvRoute  from '../middleware/envRoute';
const ENDPOINT = EnvRoute('prod'); 

const VideoComp = ({ roomId }) => {
  const [socket] = useState(() => io.connect(ENDPOINT));
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const peerConnectionRef = useRef(null);

  useEffect(() => {
    // Set up WebRTC peer connection
    const peerConnection = new RTCPeerConnection();
    peerConnectionRef.current = peerConnection;

    // Get local media stream
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
      localVideoRef.current.srcObject = stream;
      stream.getTracks().forEach((track) => peerConnection.addTrack(track, stream));
    });

    // Handle ICE candidates
    peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        socket.emit('ice-candidate', { candidate: event.candidate, room: roomId });
      }
    };

    // Handle remote stream
    peerConnection.ontrack = (event) => {
      remoteVideoRef.current.srcObject = event.streams[0];
    };

    // Handle signaling messages from the server
    socket.on('offer', async (offer) => {
      await peerConnection.setRemoteDescription(new RTCSessionDescription(offer));
      const answer = await peerConnection.createAnswer();
      await peerConnection.setLocalDescription(answer);
      socket.emit('answer', { answer, room: roomId });
    });

    socket.on('answer', async (answer) => {
      await peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
    });

    socket.on('ice-candidate', async (candidate) => {
      try {
        await peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
      } catch (e) {
        console.error('Error adding received ice candidate', e);
      }
    });

    return () => {
      // Clean up when component unmounts
      peerConnection.close();
      socket.disconnect();
    };
  }, [socket, roomId]);

  const createOffer = async () => {
    try{
        console.log('roomId:', roomId)
        const offer = await peerConnectionRef.current.createOffer();
        await peerConnectionRef.current.setLocalDescription(offer);
        socket.emit('offer', { offer, room: roomId });
    }catch(err){console.log(err)}
  };

  return (
    <div style={{position:'relative',height:'400px', overflow:'hidden'}}>
      <video ref={localVideoRef} autoPlay muted
      style={{borderRadius:'5px 0 5px 5px',boxShadow:'0 0 3px rgba( 0, 0, 0, 0.5)'}}
      ></video>
      <video ref={remoteVideoRef} autoPlay 
        style={{width:'100px',height:'auto',borderRadius:'5px',
            border:'1px solid red',
            boxShadow:'0 0 3px rgba( 0, 0, 0, 0.5)',
            position:'absolute',bottom:'0.5rem',left:'0.5rem',boxShadow:'0 0 3px rgba( 0, 0, 0, 0.5)'}}>&nbsp;</video>

      <button style={{position:'absolute',left:'0.5rem',top:'0.5rem',border:'1px solid #757575',borderRadius:'5px',
        padding:'0.25rem 0.5rem',boxShadow:'0 0 3px rgba( 0, 0, 0, 0.5)',background:'rgba(255,255,255, 0.5)'
      }}
       onClick={createOffer}>Start Call</button>
    </div>
  );
};

export default VideoComp;